import { images } from '../constants';

const mediaExtractor = (value) => {
	if (value?.arweaveAssetType === 'Image') {
		return (
			<img
				width="24"
				height="24"
				className="object-cover rounded-[4px] w-6 h-6"
				src={value?.reducedImage}
				alt={value?.reducedImage}
			/>
		);
	} else if (value?.arweaveAssetType === 'Video') {
		return (
			<img
				width="24"
				height="24"
				className="object-cover rounded-[4px] w-6 h-6"
				src={value?.videoThumbnailUri ?? images.AudioIcon }
				alt="video"
			/>
		);
	} else {
		return (
			<img
				width="24"
				height="24"
				className="object-cover rounded-[4px] w-6 h-6"
				src={images.AudioIcon}
				alt="audio"
			/>
		);
	}
};

export default mediaExtractor;
